// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecoveryPlan_title__AF3yL {
  font-weight: 700;
  font-size: 24px;
  line-height: 32.68px;
  color: #383838;
  margin-top: 1rem;
  margin-bottom: 25px;
}

.RecoveryPlan_viewDataBlockRecoveryPlan__pELDj {
  border: solid 1px #e7e0f1;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .RecoveryPlan_viewDataBlockRecoveryPlan__pELDj {
    flex-direction: column;
    align-items: stretch;
  }
}

.RecoveryPlan_viewOrgBlockItem__uNCj- {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
}

.RecoveryPlan_viewOrgBlockItemLabel__xPzCF {
  color: var(--Color-primary, #495057);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.RecoveryPlan_viewOrgValue__0PuIY {
  color: var(--Color-primary, #495057);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.RecoveryPlan_viewDataBlockPeople__wJ5kL {
  border: solid 1px #e7e0f1;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}

.RecoveryPlan_viewDataBlockPeopleItems__BNhP\\+ {
  border: solid 1px #e7e0f1;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
}

.RecoveryPlan_viewDataBlock__XkIrw {
  border: solid 1px #e7e0f1;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  gap: 16px;
}

.RecoveryPlan_viewDataBlockItem__lBs9C {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1px
}

.RecoveryPlan_viewDataBlockItemValue__mcfqm {
  width: 100%;
  background-color: #eff3f8;
  padding: 10.5px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: normal;
  min-height: 35px;
  color: #495057;
}

.RecoveryPlan_viewDataBlockItemLabel__xKMKT {
  font-weight: 700;
  font-size: 14px;
  line-height: 16.34px;
  color: #495057;
}

.RecoveryPlan_actionButton__1jDYV {
  background: transparent;
  color: var(--branded-purple);
  border: solid 1px;
  border-radius: 28px;
  padding: 10px 20px;
}

.RecoveryPlan_active__LA\\+-P {
  color: #22c55e !important;
  background-color: #d4f1e0;
}

.RecoveryPlan_inactive__xY0Sg {
  color: #c1850e;
  background-color: #fce0aa;
}

.RecoveryPlan_future__fIZY1 {
  color: dimgray;
  background-color: lightgrey;
}

.RecoveryPlan_tag__0arDu {
  border-radius: 4px;
  padding: 4px 10px 4px 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19.07px;
}

.RecoveryPlan_highPriority__XZBYI {
  color: #ED4337;
  background-color: rgba(237, 67, 55, 0.20);
}

.RecoveryPlan_mediumPriority__VpoDc {
  color: #c1850e;
  background-color: #fce0aa;
}

.RecoveryPlan_lowPriority__XF73B {
  color: #22c55e !important;
  background-color: #d4f1e0;
}

.RecoveryPlan_iconRecoveryPlanview__QoFCe {
  width: 40px;
  height: 40px;
  background-color: #DEBEED80;
  color: #873CAA;
  border: 1px solid #DEBEED80 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/styles/recoveryPlan/RecoveryPlan.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".title {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32.68px;\n  color: #383838;\n  margin-top: 1rem;\n  margin-bottom: 25px;\n}\n\n.viewDataBlockRecoveryPlan {\n  border: solid 1px #e7e0f1;\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 768px) {\n  .viewDataBlockRecoveryPlan {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.viewOrgBlockItem {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n}\n\n.viewOrgBlockItemLabel {\n  color: var(--Color-primary, #495057);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.viewOrgValue {\n  color: var(--Color-primary, #495057);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.viewDataBlockPeople {\n  border: solid 1px #e7e0f1;\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n}\n\n.viewDataBlockPeopleItems {\n  border: solid 1px #e7e0f1;\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.viewDataBlock {\n  border: solid 1px #e7e0f1;\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.viewDataBlockItem {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1px\n}\n\n.viewDataBlockItemValue {\n  width: 100%;\n  background-color: #eff3f8;\n  padding: 10.5px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n  line-height: normal;\n  min-height: 35px;\n  color: #495057;\n}\n\n.viewDataBlockItemLabel {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16.34px;\n  color: #495057;\n}\n\n.actionButton {\n  background: transparent;\n  color: var(--branded-purple);\n  border: solid 1px;\n  border-radius: 28px;\n  padding: 10px 20px;\n}\n\n.active {\n  color: #22c55e !important;\n  background-color: #d4f1e0;\n}\n\n.inactive {\n  color: #c1850e;\n  background-color: #fce0aa;\n}\n\n.future {\n  color: dimgray;\n  background-color: lightgrey;\n}\n\n.tag {\n  border-radius: 4px;\n  padding: 4px 10px 4px 10px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 19.07px;\n}\n\n.highPriority {\n  color: #ED4337;\n  background-color: rgba(237, 67, 55, 0.20);\n}\n\n.mediumPriority {\n  color: #c1850e;\n  background-color: #fce0aa;\n}\n\n.lowPriority {\n  color: #22c55e !important;\n  background-color: #d4f1e0;\n}\n\n.iconRecoveryPlanview {\n  width: 40px;\n  height: 40px;\n  background-color: #DEBEED80;\n  color: #873CAA;\n  border: 1px solid #DEBEED80 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `RecoveryPlan_title__AF3yL`,
	"viewDataBlockRecoveryPlan": `RecoveryPlan_viewDataBlockRecoveryPlan__pELDj`,
	"viewOrgBlockItem": `RecoveryPlan_viewOrgBlockItem__uNCj-`,
	"viewOrgBlockItemLabel": `RecoveryPlan_viewOrgBlockItemLabel__xPzCF`,
	"viewOrgValue": `RecoveryPlan_viewOrgValue__0PuIY`,
	"viewDataBlockPeople": `RecoveryPlan_viewDataBlockPeople__wJ5kL`,
	"viewDataBlockPeopleItems": `RecoveryPlan_viewDataBlockPeopleItems__BNhP+`,
	"viewDataBlock": `RecoveryPlan_viewDataBlock__XkIrw`,
	"viewDataBlockItem": `RecoveryPlan_viewDataBlockItem__lBs9C`,
	"viewDataBlockItemValue": `RecoveryPlan_viewDataBlockItemValue__mcfqm`,
	"viewDataBlockItemLabel": `RecoveryPlan_viewDataBlockItemLabel__xKMKT`,
	"actionButton": `RecoveryPlan_actionButton__1jDYV`,
	"active": `RecoveryPlan_active__LA+-P`,
	"inactive": `RecoveryPlan_inactive__xY0Sg`,
	"future": `RecoveryPlan_future__fIZY1`,
	"tag": `RecoveryPlan_tag__0arDu`,
	"highPriority": `RecoveryPlan_highPriority__XZBYI`,
	"mediumPriority": `RecoveryPlan_mediumPriority__VpoDc`,
	"lowPriority": `RecoveryPlan_lowPriority__XF73B`,
	"iconRecoveryPlanview": `RecoveryPlan_iconRecoveryPlanview__QoFCe`
};
export default ___CSS_LOADER_EXPORT___;
